import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './_footer-nav.scss';
import { Button } from '@snsw-gel/react';

const FooterNav = ({ onBackPressed, forwardLabel, backLabel, className, forwardLabelDisabled }) => (
    <div className={classNames('form__actions btn-section footer-nav', className)}>
        <Button
            type="submit"
            variant="primary"
            className="flex-right"
            disabled={forwardLabelDisabled}
        >
            {forwardLabel}
        </Button>

        <Button
            type="button"
            variant="secondary"
            className="flex-left"
            onClick={onBackPressed}
        >
            {backLabel}
        </Button>
    </div>
);

FooterNav.displayName = 'FooterNav';

FooterNav.propTypes = {
    forwardLabel: PropTypes.string,
    backLabel: PropTypes.string,
    onBackPressed: PropTypes.func,
    className: PropTypes.string,
    forwardLabelDisabled: PropTypes.bool
};

FooterNav.defaultProps = {
    forwardLabel: 'Next',
    backLabel: 'Back',
    onBackPressed: Function.prototype,
    className: null,
    forwardLabelDisabled: false
};

export default memo(FooterNav);
